const Conf = {
  basename : "/",
  public_url: `${process.env.PUBLIC_URL}`,
  api: {
  	base_url: "/puda-Gateway/api/"
  }
}
export default Conf;